import React, { useState } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  VKShareButton,
} from "react-share";

import "./share-button.scss";

const ShareButton = () => {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const [shareVisible, setShareVisible] = useState(false);

  const hideShare = (e) => setShareVisible(false);
  const showShare = (e) => setShareVisible(true);
  return (
    <div className="share-button">
      <span
        className={
          shareVisible === false
            ? "share-button__btn"
            : "share-button__btn share-button__btn--hidden"
        }
        onMouseOver={showShare}
        onMouseLeave={hideShare}
        onTouchStart={showShare}
      >
        <img src={require("../../assets/icons/share.svg").default} alt="" />
      </span>
      <div
        className={
          shareVisible === true
            ? "share-button__submenu share-button__submenu--visible"
            : "share-button__submenu"
        }
        onMouseOver={showShare}
        onMouseLeave={hideShare}
      >
        <FacebookShareButton url={url}>
          <img
            src={require("../../assets/icons/facebook.svg").default}
            alt="FB"
            className="share-button__submenu-icon"
          />
        </FacebookShareButton>
        <TwitterShareButton url={url}>
          <img
            src={require("../../assets/icons/twitter.svg").default}
            alt="TT"
            className="share-button__submenu-icon"
          />
        </TwitterShareButton>
        <LinkedinShareButton url={url}>
          <img
            src={require("../../assets/icons/linkedin.svg").default}
            alt="IN"
            className="share-button__submenu-icon"
          />
        </LinkedinShareButton>
        <VKShareButton url={url}>
          <img
            src={require("../../assets/icons/vk.svg").default}
            alt="VK"
            className="share-button__submenu-icon"
          />
        </VKShareButton>
      </div>
    </div>
  );
};

export default ShareButton;
